<div class="layout-topbar">
  <a
    class="layout-topbar-logo"
    routerLink=""
  >
    <img
      [src]="businessUnitLogo"
      alt="logo"
    />
    <img
      [src]="locale === 'de' ? 'assets/img/brand/bakerstreet_text_de.png' : 'assets/img/brand/bakerstreet_text_fr.png'"
      alt="logo"
    />
  </a>

  <button
    class="p-link layout-menu-button layout-topbar-button"
    #menubutton
    (click)="layoutService.onMenuToggle()"
    type="button"
  >
    <i class="pi pi-bars"></i>
  </button>

  <button
    class="p-link layout-topbar-menu-button layout-topbar-button"
    #topbarmenubutton
    (click)="layoutService.showProfileSidebar()"
    type="button"
  >
    <i class="pi pi-ellipsis-v"></i>
  </button>

  @if (showTypeformLink) {
    <a
      class="text-red-700 underline p-link layout-topbar-link mr-3"
      [href]="this.typeformUrl"
      (click)="saveTypeformClick()"
    >
      <ng-container i18n="@@topbar_user_satisfaction_survey_link">Enquête de satisfaction</ng-container>
    </a>
  }

  <div
    class="layout-topbar-menu"
    [ngClass]="{ 'layout-topbar-menu-mobile-active': layoutService.state.profileSidebarVisible }"
    #topbarmenu
  >
    <p-button
      (onClick)="op.toggle($event)"
      icon="pi pi-chevron-down"
      [label]="locale.toUpperCase()"
      [text]="true"
    />
    <p-overlayPanel #op>
      @for (lang of frontendLanguages; track lang; let i = $index) {
        @if (loc.pathname[3] === "/" && !loc.pathname.startsWith("/" + lang + "/")) {
          <a
            target="_self"
            [href]="prefixHref + '/' + lang + loc.pathname.substring(3) + loc.search"
            >{{ lang.toUpperCase() }}</a
          >
        } @else {
          {{ lang.toUpperCase() }}
        }
        @if (i !== frontendLanguages.length - 1) {
          &nbsp; | &nbsp;
        }
      }
    </p-overlayPanel>
    <app-feature-tour-button />
    <button
      class="p-link layout-topbar-button"
      type="button"
      (click)="openAssistantForHelp()"
      pTooltip="Obtenir de l'aide"
      i18n-pTooltip="@@topbar_user_help_tooltip"
    >
      <i class="fa fa-question mr-2"></i>
    </button>

    <button
      class="p-link layout-topbar-button"
      type="button"
      pTooltip="Ouvrir le chat"
      i18n-pTooltip="@@topbar_open_chat_tooltip"
      (click)="toggleChat()"
    >
      <img
        src="assets/img/icons/assistant.svg"
        alt="assistant"
      />
    </button>

    <button
      class="p-link layout-topbar-button"
      type="button"
      routerLink="/users/profile"
      pTooltip="Profil utilisateur"
      i18n-pTooltip="@@topbar_show_profile_tooltip"
    >
      <img
        class="img-avatar m-0"
        type="button"
        [src]="profileImage"
        [alt]="account.name"
        tabindex="-1"
      />
    </button>
    @if (canManageUsers) {
      <button
        class="p-link layout-topbar-button"
        type="button"
        routerLink="/users/users-tabs"
        pTooltip="Administration des droits"
        i18n-pTooltip="@@topbar_rights_management_tooltip"
      >
        <i class="fa fa-users"></i>
        <span i18n="@@topbar_access_control_label">Contrôle d'accès</span>
      </button>
    }
    <button
      class="p-link layout-topbar-button"
      type="button"
      (click)="logout()"
      pTooltip="Déconnection"
      i18n-pTooltip="@@topbar_logout_tooltip"
    >
      <i class="fa fa-sign-out"></i>
      <span i18n="@@topbar_logout_label">Déconnection</span>
    </button>
  </div>

  <p-dialog
    class="typeform-dialog"
    header="Enquête de satisfaction"
    i18n-header="@@topbar_user_survey_title"
    [modal]="true"
    [focusOnShow]="true"
    [(visible)]="showTypeformDialog"
    autoZIndex="true"
  >
    <p>
      <ng-container i18n="@@topbar_user_survey_description"
        >Une enquête de satisfaction est mise à votre disposition pour recueillir vos retours sur l'application
        Bakerstreet.<br /><br />
        Nous vous remercions de prendre quelques minutes pour y répondre via le lien suivant :
        <a
          [href]="this.typeformUrl"
          (click)="saveTypeformClick()"
          >Enquête de satisfaction</a
        >.<br /><br />
        Vous pouvez aussi y répondre ultérieurement en cliquant sur le lien dans la barre de lien en haut de la
        page.</ng-container
      >
    </p>
  </p-dialog>

  <p-dialog
    [style]="{ width: '60%' }"
    header="Règles d'utilisation de BakerStreet"
    i18n-header="@@guideline_popup_title"
    [modal]="true"
    [focusOnShow]="true"
    [(visible)]="showGuidelinePopUp"
    [closable]="false"
    autoZIndex="true"
  >
    <span i18n="@@guideline_popup_intro"
      >Veuillez prendre connaissance et accepter les conditions d'utilisation de RTS BakerStreet, conçues pour protéger
      nos cas d'usage et les données :</span
    >
    <ul i18n="@@guideline_popup_points">
      <li>La Charte IA de la RTS doit être intégrée dans l'ensemble de vos activités sur BakerStreet.</li>
      <li>
        Les modèles de prompts disponibles dans BakerStreet sont conçus conformément à notre charte éditoriale et ne
        sont pas adaptés pour un usage externe. Par conséquent, leur partage en dehors de la SSR est interdit.
      </li>
      <li>
        Les modèles conformes à nos normes (Compliant RGPD) peuvent être utilisés pour traiter des données non sensibles
        et dans nos activités professionnelles quotidiennes.
      </li>
      <li>
        Les modèles non conformes (non Compliant RGPD) peuvent servir à la stimulation des idées, à encourager la
        créativité et à rechercher des informations dans les modèles de language large comme Open AI GPT.
      </li>
      <li>
        Aucun contenu sensible, susceptible de mettre en danger la RTS, la SSR ou la vie privée des individus, ne doit
        être utilisé dans BakerStreet, à moins d'avoir été entièrement nettoyé de toutes références privées ou
        organisationnelles (anonymisation, suppression de data...).
      </li>
    </ul>
    <div class="flex align-items-center justify-content-center">
      <p-button
        (click)="saveGuidelinePopUpClick()"
        label="Je reconnais avoir pris connaissance de ces conditions et les accepte."
        i18n-label="@@guideline_popup_accept_button_label"
      />
    </div>
  </p-dialog>
</div>
